import { useEffect } from "react";
import { Button } from "@/config/antd";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const ManifestoTab = ({ manifesto, isLoading }) => {
  const navigate = useNavigate();

  useEffect(() => {}, [manifesto]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!manifesto) {
    return <div>No manifesto found</div>;
  }

  const handleViewManifesto = () => {
    navigate(`/dashboard/manifesto/${manifesto._id}`);
  };

  return (
    <div className="text-left">
      <h3 className="heading-medium font-semibold text-darkGrey mb-4">
        {manifesto.name}
      </h3>
      <p className="text-gray-600 text-small mb-4">{manifesto.description}</p>
      {manifesto.fileUrl && (
        <Button
          type="link"
          className="text-primary font-bold p-0"
          onClick={handleViewManifesto}>
          Click to View Full
        </Button>
      )}
    </div>
  );
};

ManifestoTab.propTypes = {
  manifesto: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    fileUrl: PropTypes.string,
    _id: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
};

export default ManifestoTab;
